import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import appPlay from "../assets/images/app-play.svg";
import googlePlay from "../assets/images/google-play.svg";
import mobilApp from "../assets/images/mobil-app.webp";
import Accordion from "react-bootstrap/Accordion";
import { useEffect } from "react";
import { scrollToTop } from "../utils/Helper";

const Faq = () => {
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <div className="wrapper">
      <Header isBackEnable={false} />
      <main className="main-curve-top">
        <div className="happy-left">&nbsp;</div>
        <div className="happy-right">&nbsp;</div>

        <section className="faq-sec faqPags-sec">
          <div className="container">
            <div className="head-top-content">
              <h2>
                You Asked, We Answered – FAQs <span>❓</span>
              </h2>
              <p>
                We know you have questions, and we’re here with the answers!
                Below are some of the most frequently asked questions to help
                you get the most out of our platform.
              </p>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="faq-accordion-body">
                  <label>General Questions</label>
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        How is this different from project management tools?
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          We work alongside PM tools, focusing on client
                          communication, approvals, and expectation management.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        What if my clients don’t use the platform?
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          They don’t need to! They’ll get updates via email,
                          SMS, or app—whatever they prefer.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        How will this make my projects more profitable?
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          By ensuring you never work for free—every request gets
                          approved and billed before you do the work.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        What if my projects involve frequent changes or evolving
                        scopes?
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>
                          Happy Ending is built for dynamic projects. Change
                          requests are easily converted into structured change
                          orders with optional quotes, so you’re always in
                          control of timeline and budget impacts.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                {/* <div className="faq-accordion-body">
                <label>General Questions</label>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                    What is HE?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      HE is built for freelancers, small businesses, and enterprises looking for an efficient way to manage projects and client relationships.
                      </p>
                     
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                    Who can use HE?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      HE is built for freelancers, small businesses, and enterprises looking for an efficient way to manage projects and client relationships.
                      </p>
                     
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                    How is HE different from other project management tools?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      HE is built for freelancers, small businesses, and enterprises looking for an efficient way to manage projects and client relationships.
                      </p>
                 
                    </Accordion.Body>
                  </Accordion.Item>
                
                </Accordion>
             </div>  */}
                {/* <div className="faq-accordion-body">
                <label>Getting Started</label>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                    How do I sign up for HE?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Not at all! HE is designed to be intuitive and user-friendly, making it easy for anyone to get started.
                      </p>
                     
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                    Can I try HE for free?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Not at all! HE is designed to be intuitive and user-friendly, making it easy for anyone to get started.
                      </p>
                     
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                    Do I need technical knowledge to use HE?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Not at all! HE is designed to be intuitive and user-friendly, making it easy for anyone to get started.
                      </p>
                 
                    </Accordion.Body>
                  </Accordion.Item>
                
                </Accordion>
             </div>
             <div className="faq-accordion-body">
                <label>Pricing & Plans</label>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                    What pricing plans does HE offer?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Are there any hidden fees?
                      </p>
                     
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                    Are there any hidden fees?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Are there any hidden fees?
                      </p>
                     
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                    Can I upgrade or downgrade my plan?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Are there any hidden fees?
                      </p>
                 
                    </Accordion.Body>
                  </Accordion.Item>
                
                </Accordion>
             </div>
             <div className="faq-accordion-body">
                <label>Support & Security</label>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                    What kind of support does HE offer?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Absolutely! We implement industry-standard encryption and security measures to keep your data safe.
                      </p>
                     
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                    Is my data secure with HE?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Absolutely! We implement industry-standard encryption and security measures to keep your data safe.
                      </p>
                     
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                    Can I integrate HE with other tools?
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                      Absolutely! We implement industry-standard encryption and security measures to keep your data safe.
                      </p>
                 
                    </Accordion.Body>
                  </Accordion.Item>
                
                </Accordion>
             </div>  */}
                <div className="faq-still-questions">
                  <h2>Still Have Questions?</h2>
                  <p>
                    If you have more queries, feel free to contact our support
                    team anytime!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="business-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="business-content">
                  <h3>Your Business, Your Rules – Access It Anywhere</h3>
                  <p>
                    Take control of your projects with our powerful mobile and
                    web applications. Whether you’re in the office or on the
                    move, stay connected with your clients, streamline
                    workflows, and maximize profits—all from one intuitive
                    platform.
                  </p>
                  <div className="play-btn-group">
                    <a href="#">
                      {" "}
                      <img src={appPlay} alt="appPlay" />
                    </a>
                    <a href="#">
                      {" "}
                      <img src={googlePlay} alt="googlePlay" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <img src={mobilApp} alt="mobilApp" className="mobilApp" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Faq;
